import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Dispatch} from "redux";
import {IhioReferencePrescriptionType} from "../../../../types/ihioPrescription";
import {PrescriptionReferralDetailResponseType} from "../../../../types/ihioPrescriptionFilling";
import {
    useGetOrderedPrescription,
    useGetPrescriptionReferralInfo
} from "../../../../hook/request/ihioPrescriptionFilling";
import Modal from "../../general/modal";
import {
    isHideModalDataSelector,
    isShowModalDataSelector,
    modalDataSelector,
    modalNameSelector
} from "../../../../store/selector/general";
import {general} from "../../../../store/action";
import EmptyBox from "../../general/emptyBox";
import {v4 as uuidv4} from "uuid";
import OrderedPrescriptionItem from "../../ihioPrescriptionBill/orderedPrescriptionInfoModal/orderedPrescriptionItemCard";
import ReferralItemCard from "./referralItemCard";
import Icon from "../../general/icon";

type ModalInfoProps = {
    citizenItemId?: string;
    nationalCode?: string;
    samadCode?: string;
}

type IhioPrescriptionReferralInfoProps = {
    modalData: any;
    modalName: string;
    isShowModalData: boolean;
    handleHideModal: any;
    handleResetModal: any;
}

const IhioPrescriptionReferralInfo = ({
    modalData,
    modalName,
    isShowModalData,
    handleHideModal,
    handleResetModal,
}: IhioPrescriptionReferralInfoProps) => {

    const navigate = useNavigate();

    const [showState, setShowState] = useState(false);
    const [modalInfo, setModalInfo] = useState<ModalInfoProps>({});
    const [orderedPrescriptionData, setOrderedPrescriptionData] = useState<IhioReferencePrescriptionType | null>(null)
    const [referralPrescriptionsData, setReferralPrescriptionsData] = useState<PrescriptionReferralDetailResponseType[]>([])

    const getOrderedPrescriptionRequest = useGetOrderedPrescription()
    const getPrescriptionReferralInfoRequest = useGetPrescriptionReferralInfo()

    useEffect(() => {
        if(
            isShowModalData &&
            modalName === 'ihioPrescriptionReferralInfoModal'
        ){
            setShowState(true);
            setModalInfo(modalData);
            handleResetModal();
        }
    }, [modalData, modalName])

    useEffect(() => {
        if(showState) {
            getOrderedPrescriptionRequest.mutate({nationalCode: modalInfo?.nationalCode, samadCode: modalInfo?.samadCode || ''})
            getPrescriptionReferralInfoRequest.mutate({citizenItemId: modalInfo?.citizenItemId})
        }
    }, [showState]);

    useEffect(() => {
        if(getOrderedPrescriptionRequest?.isSuccess) {
            setOrderedPrescriptionData(getOrderedPrescriptionRequest?.data?.data?.result);
        }
    }, [getOrderedPrescriptionRequest?.isSuccess]);

    useEffect(() => {
        if(getPrescriptionReferralInfoRequest?.isSuccess) {
            setReferralPrescriptionsData(getPrescriptionReferralInfoRequest?.data?.data?.result);
        }
    }, [getPrescriptionReferralInfoRequest?.isSuccess]);


    const handleSetShowModal = () => {
        setShowState(false);
        setOrderedPrescriptionData(null);
        setReferralPrescriptionsData([]);
        setModalInfo({});
        handleHideModal();
    }

    return (
        <Modal
            setShow={handleSetShowModal}
            showState={showState}
            noCloseBtn={true}
            className="w-1000 mw-100"
            bodyClassName="py-5 px-3 px-lg-5 pos-rel"
        >
            <div className='d-flex mb-4 fs-3 px-2'>
                <div className=" px-2 flex-fill align-content-center">
                    <h4 className="d-flex align-items-center title-dot font-16 font-weight-bold">
                        اطلاعات نسخه
                    </h4>
                </div>
                <span className='text-red-hover align-content-center mt-2' onClick={() => handleSetShowModal()}>
                      <Icon name='close-square'/>
                    </span>
            </div>
            <div>
                <div className="fs-5 fw-bold">
                    اطلاعات نسخه ارجاع
                </div>
                <div className={`card shadow-none border rounded-4 my-3`}>
                    <div className={'card-body'}>
                        <div className={'row row-cols-md-3 row-cols-2 mt-3'}>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    کد سماد:
                                </span>
                                <span className={'text-gray-900'}>
                                    {modalInfo?.samadCode || '-'}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    نام همکار:
                                </span>
                                <span className={'text-gray-900'}>
                                    {orderedPrescriptionData?.providerName || '-'}
                                </span>
                            </div>
                            <div className={'d-flex align-items-center mb-3'}>
                                <span className={'text-gray-600 me-3'}>
                                    تخصص:
                                </span>
                                <span className={'text-gray-900'}>
                                    {orderedPrescriptionData?.partnerName || '-'}
                                </span>
                            </div>
                        </div>
                        <div>
                            {orderedPrescriptionData?.items?.map((item) => {
                                const UUID = uuidv4()
                                return (
                                    <OrderedPrescriptionItem
                                        key={UUID}
                                        item={item}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className={'mt-5'}>
                <div className="fs-5 fw-bold">
                    بازخورد‌های ارجاع
                </div>
                {referralPrescriptionsData?.length > 0 ?
                    (referralPrescriptionsData?.map((item) => {
                            const UUID = uuidv4()
                            return (
                                <ReferralItemCard
                                    key={UUID}
                                    item={item}
                                    nationalCode={modalInfo.nationalCode}
                                />
                            )
                        })
                    ) : (
                        <div className='d-flex flex-column justify-content-center align-items-center w-100 h-100'>
                            <EmptyBox/>
                            <span className='mt-5 fs-5 fw-bold'>
                                موردی یافت نشد.
                            </span>
                        </div>
                    )
                }
            </div>

            <div className="d-flex justify-content-center mt-4 pt-2">
                <button
                    onClick={() => handleSetShowModal()}
                    className="btn btn-outline-gray flex-grow-1 py-2 mx-1"
                >
                    انصراف
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state: any) => ({
    modalData: modalDataSelector(state),
    modalName: modalNameSelector(state),
    isShowModalData: isShowModalDataSelector(state),
    isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleHideModal: () => dispatch(general.handleHideModal()),
    handleResetModal: () => dispatch(general.handleResetModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IhioPrescriptionReferralInfo);
